import { Select } from "@atoms"
import useLanguage from "./use-change-language"

import styles from "./styles.module.scss"

interface Props extends React.ComponentProps<typeof Select> {}

const options = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
]

const LanguageChooser: React.FC<Props> = (props) => {
  const { onChange, language } = useLanguage()

  return (
    <Select
      className={styles.languageSelect}
      variant="contained"
      options={options}
      defaultValue={options.find((lang) => lang.value === language)}
      isSearchable={false}
      onChange={(lang, meta) => {
        onChange((lang as any)?.value)
        props.onChange?.(lang, meta)
      }}
      {...props}
    />
  )
}

export default LanguageChooser
